import * as React from "react";

import { IEventViewProps } from "../EventView";

import { IText } from "../../../classes/Text";

import { DailyListEvent } from "./DailyListEvent";
import { DailyListNoEvent } from "./DailyListNoEvent";

import * as dates from "../../../reducers/changeTimePeriod";

const getDailyListEvents = (props: IEventViewProps, isLoading: boolean) => {
    const events: JSX.Element[] = [];

    let count = 0;
    if (!isLoading) {

        // Sort events by the time of day for daily list view (not by date+time that events start, which is the default order).
        const eventsData = props.events.slice(); // Create shallow copy of array.
        eventsData.sort((a, b) => {
            return dates.compareTimeOfDay(a.localStartDate, b.localStartDate, a.name, b.name);
        });

        let hasAnyLocations = false;
        let hasAnyCategories = false;
        for (const event of eventsData) {
            if (dates.isSameDayOrAfter(props.currentDate, event.localStartDate) && dates.isSameDayOrBefore(props.currentDate, event.localEndDate)) {
                if (event.category && event.category.trim() !== "") { hasAnyCategories = true; }
                if (event.location && event.location.trim() !== "") { hasAnyLocations = true; }
            }
        }

        for (const event of eventsData) {
            if (dates.isSameDayOrAfter(props.currentDate, event.localStartDate) && dates.isSameDayOrBefore(props.currentDate, event.localEndDate)) {
                events.push(
                    <DailyListEvent
                        event={event}
                        eventText={props.text.eventViews.event}
                        allDayText={props.text.eventViews.allDay}
                        key={count}
                        contextId={props.contextId}
                        selectedDate={props.selectedDate}
                        onText={props.text.eventViews.on}
                        pageId={props.pageId}
                        parentId={props.parentId}
                        portalId={props.portalId}
                        portletInstanceId={props.portletInstanceId}
                        showCategoryColumn={hasAnyCategories}
                        showLocationColumn={hasAnyLocations}
                        todaysDate={props.todaysDate}
                        toText={props.text.eventViews.to}
                        viewMode={props.viewMode}
                        onStartAjaxCall={props.onStartAjaxCall}
                        onSetEventId={props.onSetEventId}
                        onSetEventScreenMode={props.onSetEventScreenMode}
                        onSetiCalStartDate={props.onSetiCalStartDate}
                        onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                        onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                    />);
            }
            count++;
        }
    }

    return events;
};

const getDailyListNoEvent = (events: JSX.Element[], isLoading: boolean, noEventsTextProp: string) => {
    let noEvents: JSX.Element;

    if (events.length === 0 && !isLoading) {
        const noEventsText = noEventsTextProp;
        noEvents = <DailyListNoEvent noEventThisDayText={noEventsText} />;
    }

    return noEvents;
};

export interface IDailyListDays extends IEventViewProps {
    isLoading: boolean;
}

export const DailyListDays = (props: IDailyListDays) => {

    const events = getDailyListEvents(props, props.isLoading);
    const noEvents = getDailyListNoEvent(events, props.isLoading, props.text.eventViews.noEventsOnThisDay);

    return (
        <div className="CAL-scroll-wrapper">
            <table className="CAL-V-LV-table" role="presentation">
                <tbody>
                    {events}
                    {noEvents}
                </tbody>
            </table>
        </div>
    );
};
